import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ModalService, ClosableModal } from '../../../shared/modules/modal';

import { TbaRangeResult, DiscussRangeResultsModalPayload } from '../../../shared/models';
import { TranslationConstants, TinyTextEditor } from '../../../shared/constants';

import { RangeResultsService } from '../../../shared/services';

@Component({
  selector: 'discuss-range-results-modal',
  templateUrl: './discuss-range-results-modal.component.html',
})
export class DiscussRangeResultsModalComponent extends ClosableModal implements OnInit, OnDestroy {
  rangeResult = new TbaRangeResult();
  data: DiscussRangeResultsModalPayload;

  tinyInit = TinyTextEditor.INIT;

  private subscriptions: Subscription[] = [];

  constructor(
    protected modalService: ModalService,
    private _rangeResultsService: RangeResultsService
  ) {
    super(modalService);
    // setting close confirmation modal title
    this.confirmationModalTitle = TranslationConstants.DISCUSS_RANGE_RESULT_CLOSE_TITLE;
  }

  ngOnInit(): void {
    this.rangeResult = Object.assign({}, this.data.tbaRangeResult);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => { subscription.unsubscribe(); });
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    // if existed and deleted, save empty string
    this.rangeResult.discussion = this.rangeResult.discussion || '';

    this._rangeResultsService.edit(this.rangeResult.tbaRangeResultId, this.rangeResult).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  markFormAsTouched(form: NgForm): void {
    form.form.markAsTouched();
  }
}
